import { useEffect } from 'react';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogImage?: string;
  noIndex?: boolean;
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'AI咖 - 专业的AI提示词管理平台 | 提示词管理 | Prompt管理',
  description = 'AI咖提供专业的AI提示词管理系统，帮助您高效管理、创建、编辑和分享ChatGPT、Claude等大模型提示词。提升AI对话效率，实现智能创作与提示词管理，同时提供配套的浏览器插件和MCP服务，极大提升提示词的应用效率。',
  keywords = 'AI提示词,提示词管理,Prompt管理,ChatGPT,Claude,AI对话,AI工具,人工智能,创作助手,提示词模板,提示词收藏,AI助手,智能创作,浏览器插件,MCP服务,提示词分享,AI咖',
  canonical,
  ogImage = 'https://www.aiprompter.cc/og-image.png',
  noIndex = false
}) => {
  useEffect(() => {
    // 更新页面标题
    document.title = title;

    // 更新meta标签
    const updateMeta = (name: string, content: string) => {
      let meta = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    const updateMetaProperty = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    };

    // 基础meta标签
    updateMeta('description', description);
    updateMeta('keywords', keywords);
    updateMeta('robots', noIndex ? 'noindex, nofollow' : 'index, follow');

    // Open Graph标签
    updateMetaProperty('og:title', title);
    updateMetaProperty('og:description', description);
    updateMetaProperty('og:image', ogImage);
    updateMetaProperty('og:url', canonical || window.location.href);

    // Twitter标签
    updateMetaProperty('twitter:title', title);
    updateMetaProperty('twitter:description', description);
    updateMetaProperty('twitter:image', ogImage);

    // Canonical URL
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
      if (!link) {
        link = document.createElement('link');
        link.rel = 'canonical';
        document.head.appendChild(link);
      }
      link.href = canonical;
    }

    // 清理函数
    return () => {
      // 可以在这里清理特定页面的meta标签
    };
  }, [title, description, keywords, canonical, ogImage, noIndex]);

  return null; // 这个组件不渲染任何内容
};

export default SEOHead; 